import { useEffect, useMemo, useRef, useState } from 'react';

import { observer } from 'mobx-react';

import { useFlag } from '../../services/launchDarkly';
import { useStores } from '../../stores/useStores';
import animateValue from '../../utils/animateValue';

import './BalancePanel.scss';

export const Balance = observer(() => {
  const { walletStore, coinTypeStore } = useStores();

  const enableBalanceAnimation = useFlag('balance_animation_enabled', true);

  const animationDuration = useMemo(() => (enableBalanceAnimation ? 1500 : 100), [enableBalanceAnimation]);

  const ref = useRef<HTMLDivElement>(null);

  const [prev, setPrev] = useState(0);

  const { currentCustomValue, currentCoinValue } = walletStore;

  useEffect(() => {
    const curr = currentCustomValue ?? currentCoinValue ?? 0;
    if (curr !== prev && ref.current) {
      setPrev(curr);
      animateValue(ref.current, prev, curr, animationDuration, coinTypeStore.coinType);
    }
  }, [prev, coinTypeStore.coinType, currentCustomValue, currentCoinValue, animationDuration]);

  return (
    <>
      <div className="balance-panel-left">{coinTypeStore.coinType === 'GC' ? 'CC' : 'SC'}</div>
      <span ref={ref} className={'balance-panel-balance'} data-testid="lobby-balance-bar" id="balance">
        {prev.toLocaleString()}
      </span>
    </>
  );
});
